'use client'

/**
 * Root error boundary. `app/error.tsx` only catches errors BELOW the root
 * layout — an error thrown IN the root layout (providers, theme, auth bootstrap)
 * or during React render escapes it entirely and the user gets a blank page with
 * nothing reported. global-error.tsx is the only thing that catches those.
 *
 * We had error.tsx but no global-error.tsx, so exactly the worst class of bug —
 * "the whole app is white" — was the one going unreported.
 */
import * as Sentry from '@sentry/nextjs'
import NextError from 'next/error'
import { useEffect } from 'react'

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html>
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  )
}
